import React from 'react';
import { 
  WiDaySunny, 
  WiCloud, 
  WiCloudy, 
  WiRain, 
  WiSnow, 
  WiFog, 
  WiStrongWind, 
  WiHumidity 
} from "react-icons/wi";
import GlassPanel from '../common/GlassPanel';

const getWeatherIcon = (condition) => {
  const iconStyle = { fontSize: '5rem', marginBottom: '0.5rem', color: 'var(--accent-cyan)' };
  
  switch (condition) {
    case 'Clear': return <WiDaySunny style={iconStyle} />;
    case 'Clouds': return <WiCloud style={iconStyle} />;
    case 'Rain': case 'Drizzle': return <WiRain style={iconStyle} />;
    case 'Snow': return <WiSnow style={iconStyle} />;
    case 'Mist': case 'Fog': case 'Haze': return <WiFog style={iconStyle} />;
    default: return <WiCloudy style={iconStyle} />;
  }
};

const WeatherCard = ({ data }) => {
  if (!data) return null;

  const { name, main, weather, wind, clouds } = data;
  const description = weather[0].description;
  const condition = weather[0].main;

  return (
    <GlassPanel className="WeatherCard animate-fade">
      <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '0.2rem' }}>{name}</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '1.1rem', textTransform: 'capitalize' }}>
          {description}
        </p>
      </div>

      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        marginBottom: '2rem' 
      }}>
        {getWeatherIcon(condition)}
        <h1 style={{ fontSize: '5rem', fontWeight: '300', margin: '0.5rem 0' }}>
          {Math.round(main.temp)}°C
        </h1>
      </div>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: '1fr 1fr', 
        gap: '1rem',
        borderTop: '1px solid var(--glass-border)',
        paddingTop: '1.5rem'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
          <WiStrongWind style={{ fontSize: '2rem', color: 'var(--accent-blue)' }} />
          <div>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>Viento</p>
            <p style={{ fontWeight: '600' }}>{wind.speed} m/s</p>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
          <WiHumidity style={{ fontSize: '2rem', color: 'var(--accent-purple)' }} />
          <div>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>Humedad</p>
            <p style={{ fontWeight: '600' }}>{main.humidity}%</p>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
          <WiCloud style={{ fontSize: '2rem', color: 'var(--accent-blue)' }} />
          <div>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>Nubes</p>
            <p style={{ fontWeight: '600' }}>{clouds.all}%</p>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
          <WiDaySunny style={{ fontSize: '2rem', color: 'var(--accent-cyan)' }} />
          <div>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>Sensación</p>
            <p style={{ fontWeight: '600' }}>{Math.round(main.feels_like)}°C</p>
          </div>
        </div>
      </div>
    </GlassPanel>
  );
};

export default WeatherCard;
